module.exports =
  base: '/internal/dashboard2'
  accessDenied: '/internal/dashboard2/accessDenied'
  order:
    approvalStatus:
      base: '/internal/dashboard2/order/approvalStatus'
      updateBypass: '/internal/dashboard2/order/approvalStatus/updateBypass'
  design:
    mockupTemplate:
      qc:
        base: '/internal/dashboard2/design/mockupTemplate/qc'
        job: '/internal/dashboard2/design/mockupTemplate/qc/job'
        accept: '/internal/dashboard2/design/mockupTemplate/qc/accept'
        reject: '/internal/dashboard2/design/mockupTemplate/qc/reject'
    artwork:
      hold: '/internal/dashboard2/design/artwork/hold'
  workstation:
    orderPartRelease:
      base: '/internal/dashboard2/workstation/orderPartRelease'
    assemblyRelease:
      base: '/internal/dashboard2/workstation/assemblyRelease'
    blacklist:
      base: '/internal/dashboard2/workstation/blacklist'
      search: '/internal/dashboard2/workstation/blacklist/search'
      delete: '/internal/dashboard2/workstation/blacklist/:id'
    accountingReports:
      base: '/internal/dashboard2/workstation/accountingReports'
    postcard:
      base: '/internal/dashboard2/workstation/postcard'
      data:
        preview: '/internal/dashboard2/workstation/postcard/preview'
        print: '/internal/dashboard2/workstation/postcard/print'
    facility:
      base: '/internal/dashboard2/workstation/facility'
    timeClockDashboard:
      base: '/internal/dashboard2/workstation/timeClockDashboard'
    employeeShiftDetails:
      base: '/internal/dashboard2/workstation/employeeShiftDetails'
    simpleActionTracker:
      base: '/internal/dashboard2/workstation/simpleActionTracker'
    facilityShift:
      base: '/internal/dashboard2/workstation/facilityShift'
      search: '/internal/dashboard2/workstation/facilityShift/search'
      detail: '/internal/dashboard2/workstation/facilityShift/:shiftId'
    orderFormRun:
      activeList:
        base: '/internal/dashboard2/workstation/orderFormRun/activeList'
    productItem:
      dtg: '/internal/dashboard2/workstation/productItem/dtg'
    qc:
      base: '/internal/dashboard2/workstation/qc'
      escalated: '/internal/dashboard2/workstation/qcEscalated'
      audit: '/internal/dashboard2/workstation/qcAudit'
      auditManager: '/internal/dashboard2/workstation/qcAuditManager'
      bulk: '/internal/dashboard2/workstation/qc/bulk'
    holdList:
      base: '/internal/dashboard2/workstation/holdList/:type'
      query: '/internal/dashboard2/workstation/holdList/query'
    customization:
      foldSort: '/internal/dashboard2/workstation/customization/foldSort'
      rackScan: '/internal/dashboard2/workstation/customization/rackScan'
    dtg:
      printFail:
        base: '/internal/dashboard2/workstation/dtg/printFail'
        base2: '/internal/dashboard2/workstation/dtg/printFail2'
        log: '/internal/dashboard2/workstation/dtg/printFail/:barcode/log'
      rip:
        hold: '/internal/dashboard2/workstation/dtg/:printId/hold/:ripId'
      rip2:
        hold: '/internal/dashboard2/workstation/dtg/:ripId/hold'
        expedite: '/internal/dashboard2/workstation/dtg/:ripId/expedite'
        reset: '/internal/dashboard2/workstation/dtg/:ripId/reset'
      holdList:
        base: '/internal/dashboard2/workstation/dtg/holdList'
        base2: '/internal/dashboard2/workstation/dtg/holdList2'
      orderPart:
        status: '/internal/dashboard2/workstation/dtg/orderPart/:barcode/status'
        status2: '/internal/dashboard2/workstation/dtg/orderPart/:barcode/status2'
        expedite: '/internal/dashboard2/workstation/dtg/orderPart/:barcode/expedite'
      qc:
        bulk: '/internal/dashboard2/workstation/dtg/qc/bulk'
      ripProfileManager:
        base: '/internal/dashboard2/workstation/dtg/ripProfileManager'
    screenprint:
      qc: '/internal/dashboard2/workstation/screenprint/qc'
      qc2: '/internal/dashboard2/workstation/screenprint/qc2'
      setup:
        base: '/internal/dashboard2/workstation/screenprint/setup'
    rack:
      order:
        activateShortPull: '/internal/dashboard2/workstation/rack/order/activateShortPull'
      rackSort:
        base: '/internal/dashboard2/workstation/rack/rackSort'
        storeInstruction: '/internal/dashboard2/workstation/rack/rackSort/storeInstruction'
      reBin:
        base: '/internal/dashboard2/workstation/rack/reBin'
        remove: '/internal/dashboard2/workstation/rack/reBin/gaylord/:gaylordId/remove'
        shippingForms: '/internal/dashboard2/workstation/rack/reBin/rack/:rackId/shippingForms'
        gaylords: '/internal/dashboard2/workstation/rack/reBin/gaylords'
      reconcile:
        base: '/internal/dashboard2/workstation/rack/reconcile'
      inventoryMarshal:
        base: '/internal/dashboard2/workstation/rack/inventoryMarshal'
      orderPart2:
        base: '/internal/dashboard2/workstation/rack/orderPart2'
        barcode: '/internal/dashboard2/workstation/rack/orderPart2/barcode/:barcode'
    storageRack:
      manager: '/internal/dashboard2/workstation/storageRack/manager'
      reconcile: '/internal/dashboard2/workstation/storageRack/reconcile'
      binInfo: '/internal/dashboard2/workstation/storageRack/binInfo'
    inventory:
      adjustment:
        base: '/internal/dashboard2/workstation/inventory/adjustment'
      primeInventory:
        base: '/internal/dashboard2/workstation/inventory/primeInventory'
      primeInventoryStatus:
        base: '/internal/dashboard2/workstation/inventory/primeInventoryStatus'
      manualOrder:
        base: '/internal/dashboard2/workstation/inventory/manualOrder'
      supplementaryFetchList:
        base: '/internal/dashboard2/workstation/inventory/supplementaryFetchList'
    shipping:
      shortShipList:
        base: '/internal/dashboard2/workstation/shipping/shortShipList'
      bulk2:
        base: '/internal/dashboard2/workstation/shipping/bulk2'
      dhlManifest:
        base: '/internal/dashboard2/workstation/shipping/dhlManifest'
      autobag:
        base: '/internal/dashboard2/workstation/shipping/autobag'
      customSingle:
        base: '/internal/dashboard2/workstation/shipping/customSingle'
      customRack:
        base: '/internal/dashboard2/workstation/shipping/customRack'
      shipList2:
        base: '/internal/dashboard2/workstation/shipping/shipList2'
      custom:
        base: '/internal/dashboard2/workstation/shipping/custom'
      bulk:
        base: '/internal/dashboard2/workstation/shipping/bulk'
    internetStatus:
      base: '/internal/dashboard2/workstation/internetStatus'
    whitelistIp:
      base: '/internal/dashboard2/workstation/whitelistIp'
      aws: '/internal/dashboard2/workstation/whitelistIp/aws'
      ooShirts: '/internal/dashboard2/workstation/whitelistIp/ooShirts'
    orderApproval:
      embr:
        digitizable:
          base: '/internal/dashboard2/workstation/orderApproval/embr/digitizable'
          accept: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/accept'
          reject: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/reject'
          job: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/job'
      screenprintable:
        base: '/internal/dashboard2/workstation/orderApproval/screenprintable'
        accept: '/internal/dashboard2/workstation/orderApproval/screenprintable/accept'
        reject: '/internal/dashboard2/workstation/orderApproval/screenprintable/reject'
        job: '/internal/dashboard2/workstation/orderApproval/screenprintable/job'
      address:
        base: '/internal/dashboard2/workstation/orderApproval/address'
        accept: '/internal/dashboard2/workstation/orderApproval/address/accept'
        reject: '/internal/dashboard2/workstation/orderApproval/address/reject'
        job: '/internal/dashboard2/workstation/orderApproval/address/job'
    artworkApproval:
      queuejobs:
        base: '/internal/dashboard2/workstation/artworkApproval/queuejobs'
        query: '/internal/dashboard2/workstation/artworkApproval/queuejobs/query'
        cancel: '/internal/dashboard2/workstation/artworkApproval/queuejobs/cancel'
        prioritize: '/internal/dashboard2/workstation/artworkApproval/queuejobs/prioritize'
      embr:
        history: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/history'
        production:
          base: '/internal/dashboard2/workstation/artworkApproval/embr/production'
          job: '/internal/dashboard2/workstation/artworkApproval/embr/production/job'
          finish: '/internal/dashboard2/workstation/artworkApproval/embr/production/finish'
        qc:
          base: '/internal/dashboard2/workstation/artworkApproval/embr/qc'
          job: '/internal/dashboard2/workstation/artworkApproval/embr/qc/job'
          accept: '/internal/dashboard2/workstation/artworkApproval/embr/qc/accept'
          reject: '/internal/dashboard2/workstation/artworkApproval/embr/qc/reject'
        cs:
          base: '/internal/dashboard2/workstation/artworkApproval/embr/cs'
          job: '/internal/dashboard2/workstation/artworkApproval/embr/cs/job'
          accept: '/internal/dashboard2/workstation/artworkApproval/embr/cs/accept'
          reject: '/internal/dashboard2/workstation/artworkApproval/embr/cs/reject'
      screenprint:
        production:
          base: '/internal/dashboard2/workstation/artworkApproval/screenprint/production'
          job: '/internal/dashboard2/workstation/artworkApproval/screenprint/production/job'
          finish: '/internal/dashboard2/workstation/artworkApproval/screenprint/production/finish'
        qc:
          base: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc'
          job: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc/job'
          accept: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc/accept'
          reject: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc/reject'
        cs:
          base: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs'
          job: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs/job'
          accept: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs/accept'
          reject: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs/reject'
      dtg:
        production:
          base: '/internal/dashboard2/workstation/artworkApproval/dtg/production'
          job: '/internal/dashboard2/workstation/artworkApproval/dtg/production/job'
          finish: '/internal/dashboard2/workstation/artworkApproval/dtg/production/finish'
        qc:
          base: '/internal/dashboard2/workstation/artworkApproval/dtg/qc'
          job: '/internal/dashboard2/workstation/artworkApproval/dtg/qc/job'
          accept: '/internal/dashboard2/workstation/artworkApproval/dtg/qc/accept'
          reject: '/internal/dashboard2/workstation/artworkApproval/dtg/qc/reject'
        cs:
          base: '/internal/dashboard2/workstation/artworkApproval/dtg/cs'
          job: '/internal/dashboard2/workstation/artworkApproval/dtg/cs/job'
          accept: '/internal/dashboard2/workstation/artworkApproval/dtg/cs/accept'
          reject: '/internal/dashboard2/workstation/artworkApproval/dtg/cs/reject'
    embr:
      detail: '/internal/dashboard2/workstation/embr/:embrId/detail'
      logs: '/internal/dashboard2/workstation/embr/:embrId/logs'
      holdList:
        base: '/internal/dashboard2/workstation/embr/holdList'
      artwork:
        base: '/internal/dashboard2/workstation/embr/artwork'
      hooping:
        base: '/internal/dashboard2/workstation/embr/hooping'
      hooping2:
        base: '/internal/dashboard2/workstation/embr/hooping2'
      change:
        base: '/internal/dashboard2/workstation/embr/change'
      threadLocator:
        base: '/internal/dashboard2/workstation/embr/threadLocator'
      stitch:
        base: '/internal/dashboard2/workstation/embr/stitch'
      stitch2:
        base: '/internal/dashboard2/workstation/embr/stitch2'
      fail:
        base: '/internal/dashboard2/workstation/embr/fail'
        log: '/internal/dashboard2/workstation/embr/fail/:barcode/log'
      reset: '/internal/dashboard2/workstation/embr/:embrId/reset'
      release: '/internal/dashboard2/workstation/embr/:embrId/release'
      hold: '/internal/dashboard2/workstation/embr/:embrId/hold'
      updateDesign: '/internal/dashboard2/workstation/embr/:printEmbrId/updateDesign'
      expedite: '/internal/dashboard2/workstation/embr/:embrId/expedite'
      approval:
        job: '/internal/dashboard2/workstation/embr/job'
        approve: '/internal/dashboard2/workstation/embr/:embrId/approve'
        reject: '/internal/dashboard2/workstation/embr/:embrId/reject'
      updateColors: '/internal/dashboard2/workstation/embr/:embrId/updateColors'
      matrix2:
        jobSheet: '/internal/dashboard2/workstation/embr/matrix2/jobSheet'
    autoprint:
      staging:
        base: '/internal/dashboard2/workstation/autoprint/staging'
      print: '/internal/dashboard2/workstation/autoprint/print'
      printer:
        base: '/internal/dashboard2/workstation/autoprint/printer'
      activeSheetList:
        base: '/internal/dashboard2/workstation/autoprint/activeSheetList'
      p0manager:
        base: '/internal/dashboard2/workstation/autoprint/p0manager'
      artwork:
        base: '/internal/dashboard2/workstation/autoprint/artwork'
    digitization:
      base: '/internal/dashboard2/workstation/digitization'
      production:
        base: '/internal/dashboard2/workstation/digitization/production'
        job: '/internal/dashboard2/workstation/digitization/production'
        finish: '/internal/dashboard2/workstation/digitization/production'
      qc: '/internal/dashboard2/workstation/digitization/qc'
    orderForm:
      base: '/internal/dashboard2/workstation/orderForm'
    boxInfo:
      base: '/internal/dashboard2/workstation/boxInfo'
    mockupTemplate:
      base: '/internal/dashboard2/workstation/mockupTemplate'
    queueJobInfo:
      base: '/internal/dashboard2/workstation/queueJobInfo'
    statusCheck:
      base: '/internal/dashboard2/workstation/statusCheck'
    # TODO: remove after merging WAR-1109-vision to sp-dashboard
    receivingExtractor:
      base: '/internal/dashboard2/workstation/receivingExtractor'
    assembly:
      queue: '/internal/dashboard2/workstation/assembly/queue'
      info: '/internal/dashboard2/workstation/assembly/info'
      receiving: '/internal/dashboard2/workstation/assembly/receiving'
      rejections: '/internal/dashboard2/workstation/assembly/rejections'
      labeling: '/internal/dashboard2/workstation/assembly/labeling'
    preprint:
      presort: '/internal/dashboard2/workstation/preprint/presort'
      putAway: '/internal/dashboard2/workstation/preprint/putAway'
      sort: '/internal/dashboard2/workstation/preprint/sort'
      sortBlankOrder: '/internal/dashboard2/workstation/preprint/sortBlankOrder'
      carting: '/internal/dashboard2/workstation/preprint/carting'
      store:  '/internal/dashboard2/workstation/preprint/store'
      pull: '/internal/dashboard2/workstation/preprint/pull'
    marshal:
      store: '/internal/dashboard2/workstation/marshal/store'
      storeBulk: '/internal/dashboard2/workstation/marshal/storeBulk'
  netsuite:
    accountingReports:
      enqueue: '/internal/dashboard2/netsuite/accountingReports/enqueue'
      base: '/internal/dashboard2/netsuite/accountingReports'
  info:
    viewPricing:
      base: '/internal/dashboard2/info/viewPricing'
  employee:
    roleManager:
      base: '/internal/dashboard2/employee/roleManager'
  tools:
    featureFlag:
      base: '/internal/dashboard2/tools/featureFlag'
      gql:
        featureFlagById: '/internal/dashboard2/toosl/featureFlag/gql/featureFlagById/:featureFlagId'
        featureFlagStatus: '/internal/dashboard2/tools/featureFlag/gql/featureFlagStatus/:featureFlagId'
        searchFeatureFlags: '/internal/dashboard2/tools/featureFlag/gql/searchFeatureFlags'
        featureFlagsByIds: '/internal/dashboard2/tools/featureFlag/gql/featureFlagsByIds'
        createFeatureFlag: '/internal/dashboard2/tools/featureFlag/gql/createFeatureFlag'
        updateFeatureFlagById: '/internal/dashboard2/tools/featureFlag/gql/updateFeatureFlagById/:featureFlagId'
        deleteFeatureFlagById: '/internal/dashboard2/tools/featureFlag/gql/deleteFeatureFlagById/:featureFlagId'
        searchFeatureFlagScopes: '/internal/dashboard2/tools/featureFlag/gql/searchFeatureFlagScopes'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/dashboard2.coffee